/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * HyusnSu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Thu Mar 23 2023
 **/

import { hoverScrollCss } from "@/frameworks/designStuff/utils";
import { css } from "@emotion/react";

export const accordionStyle = (active: boolean, isParent: boolean, id: string, timer = 300, maxHeight?: string) => {
	return css`
		> .body {
			overflow: auto;
			max-height: ${maxHeight};
			transition: all ${timer + "ms"} ease-in-out;

			${hoverScrollCss()};
		}
	`;
};

export const cursorStyle = css`
	cursor: pointer;
`;
